import { IsNotEmpty } from 'class-validator';
import { Mapper } from '../../../common/ddd/mapper.base';
import { IAnalyticsEventEnum } from '../../../common/enum/calendar/analytics-event.enum';
import { SelfCalendarScoreEntity } from '../../../core/domain/entities/scores/self-calendar-score.entity';
import { GetSelfCalendarScoreResponseDto } from '../../../interface/dtos/scores/get-calendar-score-response.dto';

export class SelfCalendarScorePersistenceDto {
  @IsNotEmpty()
  [IAnalyticsEventEnum.Count]: string;

  @IsNotEmpty()
  [IAnalyticsEventEnum.TotalDuration]: string;
}

export class SelfCalendarScoreMapper
  implements
    Omit<
      Mapper<SelfCalendarScoreEntity, GetSelfCalendarScoreResponseDto>,
      'toResponse'
    >
{
  toDomain(record: SelfCalendarScorePersistenceDto): SelfCalendarScoreEntity {
    return SelfCalendarScoreMapper.toDomain(record);
  }

  static toDomain(
    record: SelfCalendarScorePersistenceDto
  ): SelfCalendarScoreEntity {
    const entity = SelfCalendarScoreEntity.create({
      count: Number(record[IAnalyticsEventEnum.Count]),
      totalTime: Number(record[IAnalyticsEventEnum.TotalDuration]),
    });
    return entity;
  }
}
